import axios from "axios";
import { toast } from "react-toastify";

const baseUrl = process.env.REACT_APP_API_PATH;

// 🔁 Reject PO
export const RejetCandidatePO = async (id) => {
    try {
        const response = await axios.put(`${baseUrl}/ebench/reject_candidate_by_admin`, id);
        toast.success('Purchase Order Rejected successfully!');
        return response;
    } catch (error) {
        toast.error(error?.response?.data?.status?.message || "Failed to reject purchase order");
        throw error;
    }
};

// ✅ Create Purchase Order
export const UpdatePurchaseOrder = async (data) => {
    try {
        const response = await axios.put(`${baseUrl}/ebench/edit_purchase_order`, data, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        toast.success("Purchase Order Updated Successfully!");
        return response;
    } catch (error) {
        toast.error(error?.response?.data?.status?.message || "Failed to create purchase order");
        throw error;
    }
};

//🔁 Change Status PO
export const ChangeStatusOfPurchaseOrder = async (orderId, status) => {
    try {
        const response = await axios.post(`${baseUrl}/ebench/interview/change-interview-status?interviewId=${orderId}&status=${status}`);
        toast.success("P.O. Status Change Successfully!");
        return response;
    } catch (error) {
        toast.error(error?.response?.data?.status?.message || "Failed to Change Status");
        throw error;
    }
};


//🔁 curreny exchange api for PO
export const CurrenciesExchangeForPurchaseOrder = async (from, to, amount) => {
    try {
        const response = await axios.get(`https://v6.exchangerate-api.com/v6/b4ab04ad6d70437103c18809/pair/${from}/${to}/${amount}`);
        return response;
    } catch (error) {
        console.log(error || "Failed to Change Status");
        throw error;
    }
};
